import BaseModel from "lib/model";
export default BaseModel.extend({
    urlRoot: "/me/session",

    props: {
        _id: ["objectId"],
        email: ["string"],
        password: ["string"],
        remember: ["boolean"],
        accesstoken: ["string"],
    },
});
